import dayjs from "dayjs";
import { LoadingOutlined } from "../Utils/imports";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { error } from "./notification";
import moment from "moment";
import { setComponentLoader, setPageLoader } from "../Redux/features/utils.slice";
import { tokenId } from "../Environments/environment";
import { generateId } from "../Utils/generateId"
dayjs.extend(customParseFormat);

export const moduleGenerateId = (module, body, data) => {
    return getModuleConfig(module, body).idGenerator(data);
  };

const getModuleConfig = (module, params) => {
    let idGenerator = () => generateId(`${module.substr(0, 2)}`); // <== @todo: REPLACE THIS WITH UUID
    let db;
    switch (module) {
      case 'plant':
        idGenerator = ({ plantName }) => generateId('', { slug: plantName }); // should generate slug from data.name
        break;
  
      case 'productionLine':
        idGenerator = ({ lineName }) => generateId('', { slug: lineName }); // should generate slug from data.name
        break;

      case 'logs':
        idGenerator = ({ lineName, timestamp, userId }) => generateId('', { slug: lineName + userId + timestamp }); // should generate slug from data.name
        break;
  
      default:
        break;
    }
    
    return { db, idGenerator };
  };

export const filterByChoice = (filterFrom, key, matchAgainst) => {
    let filteredData = filterFrom?.filter((data) => data[key] === matchAgainst)
    return filteredData;
}

export const filterByIncludes = (filterFrom, matchAgainst) => {
    let filteredData = [];
    if (filterFrom)
        Object?.keys(filterFrom)?.forEach((keyName) => {
            if (keyName.includes(matchAgainst))
                filteredData.push({ [keyName]: filterFrom[keyName] })
        })
    // console.log({ filteredData, matchAgainst, filterFrom })
    return filteredData;
}

export const timeFormatter = (string) => {
    if ((string).toString().length > 1) return string
    if ((string).toString().length < 2) return `0${string}`
}

export const validText = (text) => text.replace(/\_/g, ' ')
export const getPostFix = (text) => text.includes('CO2_Totalizer') ? 'KG' : text.includes('Brix') ? `°Bx` : text.includes('Volume of CO2 in Product') ? '' : 'Litres'
export const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > dayjs().endOf('day');
};


export const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 40,
        }}
        spin
    />
);

export const setToLocalStorage = (data, where) => {
    let validData = data || []
    localStorage.setItem(where, JSON.stringify(validData))
}

export const getFromLocalStorage = (where) => {
    return JSON.parse(localStorage.getItem(where))
}

export const isSuperAdminByEmail=(email)=> {
    return  email && email.match(/\@atompoint\.com|\@procheck\.pk/i) ? true : false;
  }

export const countUpFromTime = (countFrom) => {
    countFrom = new Date(countFrom).getTime();
    var now = new Date(),
        countFrom = new Date(countFrom),
        timeDifference = (now - countFrom);

    var secondsInADay = 60 * 60 * 1000 * 24,
        secondsInAHour = 60 * 60 * 1000;

    let days = Math.floor(timeDifference / (secondsInADay) * 1);
    let hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    let mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    let secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
    // console.log({ days, hours, mins, secs })
    countUpFromTime.interval = setTimeout(() => countUpFromTime(countFrom), 1000);
    return (
        <div>{hours}</div>
    )
}

export const capitalizeLetterFunc = match => match.toUpperCase();
export const formatCapabilities = (str) => {
    return str.replace(/[-]/g, " ").replace(/([A-Z])/g, ' $1').replace(/(^\w{1})|(\s{1}\w{1})/g, capitalizeLetterFunc)
}

export const getDateRange = (today = new Date(), type = 'yesterday') => {
    let start, end;
    if (type == 'yesterday') {
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
        end = `${moment(today).format('YYYY-MM-DD')}T02:00:00.000Z`
        start = `${moment(yesterday).format('YYYY-MM-DD')}T01:59:00.000Z`
        return { start, end }
    }
    if (type == 'tomorrow') {
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)
        end = `${moment(today).format('YYYY-MM-DD')}T02:00:00.000Z`
        start = `${moment(tomorrow).format('YYYY-MM-DD')}T01:59:00.000Z`
        return { start, end }
    }

}

export const dateFormatter = (date, toFormat = "YYYY-MM-DD") => {
    return moment(date).format(toFormat)
}

export const validateForMerge = (array) => {
    if (!array.length)
        return { error: "Please select a downtime.", isValid: false }
    if (array?.length !== 2)
        return { error: "Can only select two consecutive downtimes.", isValid: false }
    array?.forEach((item) => {
        if (!item.ended) return { error: "Can not merge downtimes which haven't ended.", isValid: false }
    })
    array.sort((a, b) => a.key - b.key)
    if ((array[0].key + 1) !== (array[1].key))
        return { error: "Downtimes can only be consecutive.", isValid: false }
    return { isValid: true }
}

export const validateForSplit = (array) => {
    if (!array.length)
        return { error: "Please select a downtime.", isValid: false }
    if (array.length > 1)
        return { error: "Can only select one downtime.", isValid: false }
    if (!array[0].ended)
        return { error: "Can not merge downtimes which haven't ended.", isValid: false }
    return { isValid: true }
}

export const splitSelectionCriteria = (selected, start, end) => {
    // console.log({
    //     selected: moment(start).format('YYYY-MM-DD') + 'T' + selected + '.000Z',
    //     start: moment(start).format('YYYY-MM-DDTHH:mm:ss.ms'),
    //     end: moment(end).format('YYYY-MM-DDTHH:mm:ss.ms')
    // })
    let selectedTime = moment(start).format('YYYY-MM-DD') + 'T' + selected + '.0000'
    let ending = moment(end).format('YYYY-MM-DDTHH:mm:ss.ms')
    let starting = moment(start).format('YYYY-MM-DDTHH:mm:ss.ms')
    if (!selected)
        return { error: "Please select a split time.", disabled: true, isValid: false }
    if (selectedTime > ending)
        return { error: "Split time should be less than downtime end time.", disabled: true, isValid: false }
    if (selectedTime < starting)
        return { error: "Split time should be not be less than downtime start time.", disabled: true, isValid: false }
    return { disabled: false, isValid: true }
}

export const getDuration = (start, end) => {
    let duration = moment.duration(new moment(end).diff(new moment(start)))._data
    return duration
}

export const canForceStop = (current, lists) => {
    let { line,machine } = current;
    let machineStatus;
    let key =  (machine&&machine.machineName !=='default'? (machine.machineName + ' ') : '') + 'status'  
    //console.log(key,'keyyyy');
    machineStatus = line?line[key]:null; 
    //Object.keys(line || {})?.forEach((key) => {
      //  if (key.includes(`${current?.machine?.machineName} status`))
      //      machineStatus = line[key]
    //})
    if (machineStatus?.status == 'shift ended')
        return false
    return true
}

export const generateRoomId = (current) => {
    let { line, machine, plant, hall } = current;
    let ids = {
        line: line?.id + '-stats',
    }
    return ids;
}

export const loadComponent = (dispatch, component) => {
    dispatch(setComponentLoader({ component, flag: true }))
}
export const unLoadComponent = (dispatch, component) => {
    dispatch(setComponentLoader({ component, flag: false }))
}

export const loadPage = (dispatch, page) => {
    dispatch(setPageLoader({ page, flag: true }))
}
export const unLoadPage = (dispatch, page) => {
    dispatch(setPageLoader({ page, flag: false }))
}

export const convertSecsToTime = (secs) => moment.utc(secs * 1000).format('HH:mm:ss')

export const refineDateTime = (time) =>
    moment('2023-01-01')
        .startOf('day')
        .seconds(time)
        .format('H:mm:ss')

export const lengthChecker = (array) => array?.length ? array : []
export const formatDate = (date, format) => (moment(date).format(format))?.toString();

export const setDataForChart = (singleDoc, timezone) =>{
    if(!singleDoc)
    return [];
    console.log(singleDoc)
    let { oee = [], downtimeLog = [], disconnectLog = [] } = singleDoc;
    let modifiedData = [...oee];
    console.log("Single", singleDoc)

    if (downtimeLog.length > 0)
      downtimeLog.forEach((log) => {
        // if(log.reason.includes("Batch")){
        // }
        let containsBatch = false;
        if (log.batchNumber) {
          console.log("dtlog", log)
        }
        let started = moment(log.started).valueOf(),
          ended = log.ended ? moment(log.ended).valueOf() : moment().valueOf();
        modifiedData = modifiedData.map((item) => {
          let time = moment(item.time['_seconds'] ? item.time['_seconds'] * 1000 : item.time).valueOf();
          if (started < time && time <= ended) {
            if (log.isPlanned || item.isPlannedDowntime)
              item.planDowntime = Number(item.value) == 0 ? 5 :Number(item.value)>0 && Number(item.value) <= 2 ? 2 : Number(item.value);
            else 
            {
              item.down = Number(item.value) == 0 ? 5 :Number(item.value)>0 && Number(item.value) <= 2 ? 2 : Number(item.value);
              item.isStop = log.isStop?item.down:null;
            }
            if (log.batchNumber && !containsBatch) {
              item.batchNumber = log.batchNumber
              containsBatch = true
            }
          }

          return item;
        });
      });

    disconnectLog.forEach((log) => {
      let started = moment(log.started).valueOf(),
        ended = log.ended ? moment(log.ended).valueOf() : moment().valueOf();
      modifiedData = modifiedData.map((item) => {
        let time = moment(item.time['_seconds'] ? item.time['_seconds'] * 1000 : item.time).valueOf();
        if (started < time && time <= ended) {
          if (log.isPlanned || item.isPlannedDowntime)
            item.planDowntime = Number(item.value) == 0 ? 5 :Number(item.value)>0 && Number(item.value) <= 2 ? 2 : Number(item.value);
          else item.disconnect = Number(item.value) == 0 ? 5 :Number(item.value)>0 && Number(item.value) <= 2 ? 2 : Number(item.value);
        }
        return item;
      });
    });
    let formatedData = modifiedData.map((item) => {
      const {
        time,
        status,
        value,
        availability,
        performance,
        quality,
        goodOutput,
        downtime,
        disconnectTime,
        productChanged,
        down,
        isStop,
        previousProduct,
        disconnect,
        planDowntime,
        totalRejections,
        batchNumber,
        speedInMinute,
        lineSpeed,
        totalCountOutput,
        idealOutputForGraph,
        averageSpeedForGraph,
      } = item;
      return {
        time: moment(time).toDate().toLocaleString("en-US", { timeZone: timezone }),
        timestamp: moment(time).toDate(),
        oee: parseFloat(value),
        a: Math.round(availability),
        p: Math.round(performance),
        q: Math.round(quality),
        downtime: Math.round(downtime),
        disconnectTime: Math.round(disconnectTime),
        productChanged,
        previousProduct,
        down: down,
        isStop:isStop,
        planDowntime,
        disconnect,
        gc: goodOutput,
        idealOutputForGraph:idealOutputForGraph?idealOutputForGraph.toFixed(0):0,
        averageSpeedForGraph:averageSpeedForGraph?averageSpeedForGraph.toFixed(0):0,
        totalRejections: totalRejections,
        batchNumber,
        speedInMinute:speedInMinute,
        lineSpeed,
        status: status
      };
    });
    singleDoc.formattedOEE = formatedData;
    return formatedData;
  }
export const checkLineStatus = (oee = {}, downtimes = [],disconnects = [], current) => {
    // console.log({ oee: oee.time, downtimes })
    let status = null//current?.line?.status?.status === 'up' ? 'up' : current?.line?.status?.status
    downtimes?.forEach(({ started, ended, _id, id }) => {
        // If Downtime strted is greater than OEE time
        if (new Date(oee.time) >= new Date(started) && new Date(oee.time) < new Date(ended))
            status = 'down'
    })
    disconnects?.forEach(({ started, ended, _id, id }) => {
        // If Downtime strted is greater than OEE time
        if (new Date(oee.time) >= new Date(started) && new Date(oee.time) < new Date(ended))
            status = 'disconnect'
    })
    if(status==null)
        status='up'
    //if(status==null)
    //status = current?.line?.status?.status === 'up' ? 'up' : current?.line?.status?.status
    return status
}

export const getPreviousProduct = (kpis,timezone) => {
    //if (!current.line) return
    //if (!current.shift) return
    //const { stats: kpis = {} } = useSelector(state => state?.kpis)
    let productDetails = {};
    //let { line: { shifts }, shift } = current;
    let currentPro = null;//{name:kpis?.shift?.product?.name,range:null}
    let previous = null;
    if(kpis.productLog){
        let productLog = kpis.productLog;
        productLog?.forEach((item, i) => {
            if(item.detailsAfter)
            {
                let temp={
                    name:item.detailsBefore?.product?.name ,
                    rangeFrom:moment(item?.fromTime).toDate().toLocaleString("en-US", { timeZone: timezone }),
                    rangeTo:moment(item?.toTime).toDate().toLocaleString("en-US", { timeZone: timezone })
                };
                previous = temp;
            }
            else{
                let temp={name:item.detailsBefore?.product?.name ,
                    rangeFrom:moment(item?.fromTime).toDate().toLocaleString("en-US", { timeZone: timezone }),
                    rangeTo:moment(item?.toTime).toDate().toLocaleString("en-US", { timeZone: timezone })
                    };
                currentPro = temp;
            }
        })
    }
    productDetails = {currentPro:currentPro,previous:previous}
    console.log(productDetails);
    return productDetails;
    /*let index = null
    shifts?.forEach((item, i) => {
        if (item.name === shift.name)
            index = i
    })
    if (index == 0)
        return null
    return shifts[index - 1]*/
}

export const checkSession = (navigate) => {
    let accessToken = getFromLocalStorage(`authToken-${tokenId}`)
    if (!accessToken) navigate('/')
}

export const navigator = {}





export const canPerformAction = (current, capability) => {
    let { role = null } = current;
    if (!role?.capabilities?.includes(capability))
        return false
    return true
}